<template>
  <section class="section"
    :class="{
      'bg-light2': background
    }">
    <div class="container container-small row"
      :class="{'row-reverse': layout && layout === 'right'}">
      <div class="col" v-if="description && description.text">
        <div class="section-text slide-in"
           :class="{'visible' : visible}">
          <p class="text-m paragraph">
            {{ description.text }}
          </p>
          <div class="section-link" v-if="description.title && link">
            <router-link :to="link" class="btn btn-simple">
              {{ description.title }}
            </router-link>
          </div>
        </div>
      </div>
      <div class="col section-image" v-if="image">
        <AnimatedImage :id="image" :visible="visible" />
      </div>
    </div>
  </section>
</template>
<script>
import AnimatedImage from '@/components/AnimatedImage.vue'

export default {
  name: 'OverflowImageSection',
  props: ['description', 'background', 'layout', 'image', 'link', 'visible'],
  components: {
    AnimatedImage
  }
}
</script>

<style scoped lang="scss">
  .section {

    .container {
      padding: 0;
    } // END .container;

    &-text {
      padding: $gap-md 0;
    } // END.section-text;

    &-image {
      align-items: flex-end;
      display: flex;
      position: relative;
    }

    p {
      min-height: 100px;
      padding: 40px 0 1em 0;
      text-align: left;
      width: 100%;
      max-width: 350px;
    } // END p;

    &-link {
      text-align: right;
    } // END .section-link;

    @include screen ('sm') {
      p {
        padding: 35px 0 50px 50px;
      }

      &-link {
        text-align: left;
      } // END .section-link;
    } // END @include screen ('sm');

    @include screen ('md') {
      .container {
        min-height: 28em;
      } // END .container;

      &-text {
        padding: $gap-xl 0 ($gap-xl * 2);
      } // END.section-text;

      p {
        padding: 35px 0 30px 100px;
      }
    } // END @include screen ('md');

  } // END .section

</style>
